import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Declarant } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface EditDeclarantProps {
  declarant: Partial<Declarant>;
  declarantId: string;
}

export const useEditDeclarant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ declarant, declarantId }: EditDeclarantProps) => {
      await request({
        path: 'declarant',
        method: 'PATCH',
        authenticate: true,
        dataObject: { _id: declarantId, ...declarant },
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['admin-declarant', variables.declarantId] });
      queryClient.invalidateQueries({ queryKey: ['admin-declarants'] });
      toast.success('Declarant edited successfully!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error editing declarant!');
    },
  });
};
